import { injectable } from 'inversify';
import { army_list_unit_troop_dto, troop_carac_full } from '@Api';
import { TroopCarac, UnitCaracType } from '@Models';

@injectable()
export class TroopCaracMapper {
  public map(item: troop_carac_full): TroopCarac {
    return {
      size: item.size,
      type: this.mapType(item.type),
      agi: item.agi,
      ap: item.ap,
      att: item.att,
      of: item.of,
      str: item.str,
      M: item.M,
      A: item.A,
      BS: item.BS,
      E: item.E,
      I: item.I,
      LD: item.LD,
      S: item.S,
      T: item.T,
      W: item.W,
      WS: item.WS,
      troop_type: item.troop_type
        ? {
            id: item.troop_type.id,
            name: item.troop_type.name,
          }
        : null,
    } satisfies TroopCarac as TroopCarac;
  }

  public mapType(item: troop_carac_full.type): UnitCaracType {
    switch (item) {
      case troop_carac_full.type.V3:
        return UnitCaracType.V3;
      case troop_carac_full.type.V2:
        return UnitCaracType.V2;
    }

    return UnitCaracType.V1;
  }

  public mapTypeDto(item: UnitCaracType): army_list_unit_troop_dto.type_carac {
    switch (item) {
      case UnitCaracType.V3:
        return army_list_unit_troop_dto.type_carac.V3;
      case UnitCaracType.V2:
        return army_list_unit_troop_dto.type_carac.V2;
    }

    return army_list_unit_troop_dto.type_carac.V1;
  }
}
